// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3H6l7","footer":"styles_footer__fBVNn"};